import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import { ProductType } from "@repo/api";
import { cs, useIsDesktop } from "@repo/ui";
import contactsImg from "@repo/ui/assets/images/contacts.png";
import { useMemo, type FC, type PropsWithChildren } from "react";
import { LoggedInBar } from "../../components/AppBar/Bars";
import { BottomNavigationDesktopComponent } from "../../components/BottomNavigation";
import Consultants from "../../components/Contacts/Consultants";
import General from "../../components/Contacts/General";
import { getContractTypeToProductName } from "../../components/Contract/Utils/contractUtils";
import { Seo } from "../../components/SEO";
import { Tabs } from "../../components/Tabs";
import withProtection from "../../highOrderComponents/withProtection";
import { useContacts } from "../../queryHooks";

export const AppBar: FC = () => <LoggedInBar BottomNavigationComponent={BottomNavigationDesktopComponent} />;

export const ContactsImageWrapper = styled("div")<{ image: string }>`
    background-image: url(${(props) => props.image});
    background-size: 25%;
    background-repeat: no-repeat;
    background-position: 220px 12px;
`;

export const ContactsImage: FC<PropsWithChildren> = ({ children }) => {
    return <ContactsImageWrapper image={contactsImg}>{children}</ContactsImageWrapper>;
};

const Contacts: FC = () => {
    const isD = useIsDesktop();
    const { data, isLoading } = useContacts();

    const notPensionContact = () => {
        if (!isLoading) {
            return data.filter(
                (client) =>
                    client.productName !== getContractTypeToProductName(ProductType.Uf) &&
                    client.productName !== getContractTypeToProductName(ProductType.Pf),
            );
        }
    };
    const resultNotPensionContact = notPensionContact();

    const tabs = useMemo(() => {
        return !isLoading && resultNotPensionContact && resultNotPensionContact.length > 0
            ? [
                  { label: cs.contrct.tabs.generalContacts, slug: "vseobecne-kontakty" },
                  { label: cs.contrct.tabs.brookerContact, slug: "kontakty-na-poradce" },
              ]
            : [{ label: cs.contrct.tabs.generalContacts, slug: "vseobecne-kontakty" }];
    }, [isLoading, resultNotPensionContact?.length]);

    if (isD)
        return (
            <Grid container>
                <Grid item md={5}>
                    <General />
                </Grid>
                <Grid item md={1} />
                <Grid item md={6}>
                    {!isLoading ? <Consultants consultants={notPensionContact()} /> : <Skeleton />}
                </Grid>
            </Grid>
        );

    return (
        <Tabs queryParamKey="main-tab" tabs={tabs}>
            <General />
            {!isLoading ? <Consultants consultants={notPensionContact()} /> : <Skeleton />}
        </Tabs>
    );
};

export default withProtection(Contacts);

export const Head: FC = () => (
    <Seo
        description="Volejte 244 090 800 od pondělí do pátku od 8 do 18 hodin. Nebo nám napište na dotazy@nn.cz."
        title="Kontakty"
    />
);
